import { useState, useEffect } from 'react'
import fetchCellDetail from '../helpers/intelligence/fetchCellDetail'

/**
 * Het detail van één cel. Drie toestanden apart: 'deze cel bestaat niet' is
 * een bewering en mag pas na een gelukte read.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {string} cellId - '' = nog niet bekend, dan geen aanroep
 * @returns {{data: (object|null), loading: boolean, loaded: boolean, error: (Error|null)}}
 */
const useCellDetail = (cellId) => {
    const [data, setData] = useState(/** @type {object|null} */(null))
    const [loaded, setLoaded] = useState(false)
    const [error, setError] = useState(/** @type {Error|null} */(null))

    useEffect(() => {
        if (!cellId) return undefined
        let cancelled = false
        setLoaded(false)
        setError(null)
        setData(null)
        fetchCellDetail(cellId)
            .then((result) => {
                if (cancelled) return
                setData(result)
                setLoaded(true)
            })
            .catch((err) => {
                if (cancelled) return
                console.error('useCellDetail:', err)
                setError(err)
                setData(null)
                setLoaded(false)
            })
        return () => { cancelled = true }
    }, [cellId])

    return { data, loading: !loaded && error === null, loaded, error }
}

export default useCellDetail
